const getSecondsFromTimeString = function(timeString="",sep=":") {
    let seconds = 0;
    timeString.split(sep).reverse().forEach((val, index) => {
        seconds += parseInt(val) * (60 ** index);
    })
    return seconds;
}

export { getSecondsFromTimeString }